import { coreToTCData, encodeCore } from '../lib/tcf/core.js';
import { encodePublisher } from '../lib/tcf/publisher.js';
const TCF_ENABLE = (typeof process !== 'undefined' && process.env?.['TCF_ENABLE']) === '1';
const TCF_PUB_ENABLE = (typeof process !== 'undefined' && process.env?.['TCF_PUB_ENABLE']) === '1';
let VENDOR_CAP = 64;
export function setTcfVendorCap(maxVendorId) {
    const n = Number.isFinite(maxVendorId) ? Math.floor(maxVendorId) : 0;
    VENDOR_CAP = Math.max(1, Math.min(4096, n));
}
let currentCore = null;
let currentPublisher = null;
const listeners = new Map();
let listenerSeq = 0;
export function setCoreModel(m) {
    currentCore = m;
    notify();
}
export function setPublisherModel(m) {
    currentPublisher = m;
    notify();
}
function notify() {
    if (!TCF_ENABLE)
        return;
    for (const [, cb] of listeners)
        cb(getTCDataInternal(), true);
}
function buildTcString() {
    if (!currentCore)
        return null;
    const coreSeg = encodeCore(currentCore, { maxVendorId: VENDOR_CAP });
    if (TCF_PUB_ENABLE && currentPublisher) {
        const pubSeg = encodePublisher(currentPublisher);
        return `${coreSeg}.${pubSeg}`;
    }
    return coreSeg;
}
function getTCDataInternal() {
    if (!currentCore)
        return null;
    const tcString = buildTcString();
    const base = coreToTCData(currentCore);
    base['tcString'] = tcString;
    const isDev = typeof process !== 'undefined' &&
        process.env &&
        process.env['NODE_ENV'] !== 'production';
    if (isDev) {
        base['devCoreString'] = encodeCore(currentCore, {
            maxVendorId: VENDOR_CAP,
        });
    }
    if (currentPublisher) {
        base['publisher'] = {
            purposes: {
                consents: currentPublisher.pubPurposesConsent,
                legitimateInterests: currentPublisher.pubPurposesLITransparency,
            },
        };
    }
    return base;
}
export function installTcfCoreApiOnWindow(w) {
    const win = w;
    if (win.__tcfapi)
        return;
    win.__tcfapi = (command, _version, callback) => {
        if (!TCF_ENABLE)
            return callback(null, false);
        switch (command) {
            case 'ping':
                return callback({
                    gdprApplies: !!currentCore?.gdprApplies,
                    cmpLoaded: true,
                    tcfPolicyVersion: currentCore?.policyVersion ?? null,
                }, true);
            case 'getTCData':
                return callback(getTCDataInternal(), true);
            case 'addEventListener': {
                const id = ++listenerSeq;
                listeners.set(id, callback);
                return callback({ listenerId: id }, true);
            }
            case 'removeEventListener':
                return callback({ removed: true }, true);
            default:
                return callback(null, false);
        }
    };
}
//# sourceMappingURL=tcf-core-api.js.map